import React, { Component } from 'react';
import { Alert, Col, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import { authApi } from '../../../services/api/auth-api';
import queryString from 'query-string';
import { Link, withRouter } from 'react-router-dom';
import SimpleErrorList from '../../shared/errors/SimpleErrorList';
import './ResetPassword.css';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      passwordConfirmation: '',
      errors: [],
    };

    const params = queryString.parse(this.props.location.search);
    this.clientId = params['client_id'];
    this.token = params['token'];
    this.uid = params['uid'];
  }

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  };

  handlePasswordConfirmationChange = (event) => {
    this.setState({ passwordConfirmation: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    authApi
      .resetPassword(
        this.state.password,
        this.state.passwordConfirmation,
        this.clientId,
        this.token,
        this.uid
      )
      .then((response) => {
        if (response.ok) {
          this.props.history.push('/login');
        } else {
          this.setState({
            errors: response.errors.full_messages,
          });
        }
      });
  };

  render() {
    return (
      <div className="client reset-password">
        <Grid>
          <Row>
            <Col md={6} mdOffset={3}>
              <div className="title">
                <span>Reset your password</span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6} mdOffset={3}>
              <div className="form-container">
                <form onSubmit={this.handleSubmit}>
                  <Col md={12}>
                    <FormGroup>
                      <FormControl
                        type="password"
                        className="input"
                        value={this.state.password}
                        placeholder="Password"
                        onChange={this.handlePasswordChange}
                        required
                      />
                    </FormGroup>
                  </Col>

                  <Col md={12}>
                    <FormGroup>
                      <FormControl
                        type="password"
                        className="input"
                        value={this.state.passwordConfirmation}
                        placeholder="Password confirmation"
                        onChange={this.handlePasswordConfirmationChange}
                        required
                      />
                    </FormGroup>
                  </Col>

                  {this.state.errors.length > 0 && (
                    <Col md={12}>
                      <SimpleErrorList errors={this.state.errors} />
                    </Col>
                  )}

                  {this.showWarning() && (
                    <Col md={12} className="warning-container">
                      <Alert bsStyle="warning">
                        Some parameters are missing, please go{' '}
                        <strong>
                          <Link to="/recover-password">here</Link>
                        </strong>{' '}
                        to properly recover your password.
                      </Alert>
                    </Col>
                  )}

                  <Col md={12}>
                    <FormGroup>
                      <input
                        type="submit"
                        className="btn-select btn-orange"
                        value="Reset"
                      />
                    </FormGroup>
                  </Col>
                </form>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }

  showWarning = () => {
    return (
      this.clientId === '' ||
      this.token === '' ||
      this.uid === '' ||
      this.uid === undefined
    );
  };
}

export default withRouter(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/client/recover/ResetPassword.js